var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBorderW16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87386 6.07987L14.6672 6.49321L11.0339 9.64654L12.1205 14.3332L8.00053 11.8465L3.88053 14.3332L4.97386 9.64654L1.33386 6.49321L6.1272 6.08654L8.00053 1.66654L9.87386 6.07987ZM5.49319 12.1134L7.99986 10.6L10.5132 12.12L9.84652 9.26671L12.0599 7.34671L9.13986 7.09338L7.99986 4.40004L6.86652 7.08671L3.94652 7.34004L6.15986 9.26004L5.49319 12.1134Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorderW16);
export default __webpack_public_path__ + "static/media/star_border_w16.6875e8bbef96e55ce2664c62ebc345c9.svg";
export { ForwardRef as ReactComponent };